import { create } from 'zustand'

export const useOrganizationArtistsStore = create(set => ({
  searchTerm: '',
  inputValue: '',
  setSearchTerm: newText => set({ searchTerm: newText }),
  setInputValue: newText => set({ inputValue: newText }),
}))
